/**
 * streams-select
 *
 * @author    Augusto Silvino <augusto.silvino@mediatel.co.uk>
 * @copyright 2017 Mediatel Limited.
 */

"use strict";

import getSelectedOptions from "../common/get-selected-options";

export default (settingOptions = {}) => sb => {
    let settings,
        streamsSelect;

    const fetchStreams = function fetchPlatforms() {
        return sb.postApi("/tv-player-report/get-streams").then(streams => {
            sb.notify({ type: "streamsLoaded", data: streams });

            return streams;
        });
    };

    const populateStreamsSelect = function populateStreamsSelect(streams) {
        let options = streams.map(stream => {
            return `<option value="${stream.id}">${stream.name}</option>`;
        });

        if (settings.labelAll.length > 0) {
            options.unshift([`<option value="">${settings.labelAll}</option>`]);
        }

        sb.append(streamsSelect, options.join("\n"));
        onStreamsSelectionChange();

        return streams;
    };

    const onStreamsSelectionChange = function onStreamsSelectionChange() {
        sb.notify({
            type: "streamsSelectionChanged",
            data: [].map.call(
                getSelectedOptions(streamsSelect[0]),
                option => option.value
            )
        });
    };

    const initSettings = function initSettings() {
        settings = (typeof settingOptions !== "object") ? {} : settingOptions;
        settings.selectedLabel = settingOptions.selectedLabel || '';
        settings.labelAll = settingOptions.labelAll || '';
    };

    return {
        init() {
            initSettings();

            streamsSelect = sb.find("#stream");
            sb.addEvent(streamsSelect[0], "change", onStreamsSelectionChange);

            fetchStreams().then(populateStreamsSelect);
        },
        destroy() {
            sb.removeEvent(streamsSelect[0], "change", onStreamsSelectionChange);
            streamsSelect = null;
        }
    }
}